export default "__VITE_ASSET__cb1e195d__"